import * as THREE from 'three';
import settings from './config/Settings';
import utils from './utils';

class LabelFactory {
  createLabel(type, text, scaleCoefficient = 10) {
  	const fontFace = settings.typography.fontFace
    const fontSize = settings.typography.fontSize
    const textWidth = this.getTextWidth(text, fontSize, fontFace)
    const canvas = document.createElement('canvas')
    // Round up canvas width to the nearest power of 2.
    // Otherwise THREE.js will automatically round up and distort the text.
    canvas.width = utils.nearestPow2(textWidth)
    canvas.height = canvas.width
    // canvas.height = canvas.width

    let color, verticalAlign, xStart, yStart, scaleLogCoefficient
    switch (type) {
      case 'planet':
        color = '#FFFFFF'
        verticalAlign = 'bottom'
        xStart = canvas.width / 2
        yStart = (canvas.height - this.getTextHeight(fontFace, fontSize))/ 2
        // scaleCoefficient = scaleCoefficient
        scaleLogCoefficient = 2
        break
      case 'sun':
        color = '#FFD667'
        verticalAlign = 'middle'
        xStart = canvas.width / 2
        yStart = canvas.height / 2
        // scaleCoefficient = scaleCoefficient
        scaleLogCoefficient = 2
        break
      case 'star':
        color = '#FFD667'
        verticalAlign = 'bottom'
        xStart = canvas.width / 2
        yStart = (canvas.height - this.getTextHeight(fontFace, fontSize))/ 2
        // scaleCoefficient = scaleCoefficient
        scaleLogCoefficient = 2
        break
      default:
        break
    }
    const texture = new THREE.CanvasTexture(canvas)
    const spriteMaterial = new THREE.SpriteMaterial({
      map: texture,
      blending: THREE.AdditiveBlending,
      color: 0xffffff,
      depthTest: false,
    })

    const label = new THREE.Sprite(spriteMaterial)
    label.canvasWidthCoefficient = canvas.width / 1000
    label.scaleCoefficient = scaleCoefficient
    label.scaleLogCoefficient = scaleLogCoefficient


  	let context = canvas.getContext('2d')
    // if(!failed) {
    //   context = null
    //   failed = true;
    // }
    // set text font
    context.font = "Bold " + fontSize + "px " + fontFace
    // set text color
    context.fillStyle = color
    // center text horizontally
    context.textAlign = "center"

    context.textBaseline = verticalAlign
    context.fillText(text, xStart, yStart)

    // // label outline
    // context.strokeStyle = 'yellow';
    // context.lineWidth = 5;
    // context.rect(0, 0, canvas.width, canvas.height);
    // context.stroke()

  	// canvas content used as texture
    return label;
  }

  getTextWidth (text, fontSize, fontFace) {
    var canvas = document.createElement('canvas')
    if(!canvas) return 0;
  	var context = canvas.getContext?.('2d')
    if(!context) return 0;
  	context.font = "Bold " + fontSize + "px " + fontFace
  	return context.measureText(text).width
  }

  getTextHeight (font, size) {
    const div = document.createElement("div");
    if(!div) return 0;
    div.innerHTML = 'Hg';
    div.style.position = 'absolute';
    div.style.top  = '-9999px';
    div.style.left = '-9999px';
    div.style.fontFamily = font;
    div.style.fontWeight = 'normal';
    div.style.fontSize = size + 'px';
    document.body.appendChild(div);
    var textHeight = div.offsetHeight;
    if(!textHeight) return 0;
    document.body.removeChild(div);
    return textHeight
  };
}

export default new LabelFactory()
